import { ArrowRight } from 'lucide-react'

interface SuggestAgentModeCardProps {
  data: {
    reason?: string
    task_summary?: string
  }
  onSwitchToAgent?: () => void
  onContinueInChat?: () => void
}

export function SuggestAgentModeCard({ data, onSwitchToAgent, onContinueInChat }: SuggestAgentModeCardProps) {
  return (
    <div className="suggest-agent-card">
      <div className="suggest-agent-card__body">
        <div className="suggest-agent-card__icon">
          <ArrowRight size={18} />
        </div>
        <div className="suggest-agent-card__text">
          <p className="suggest-agent-card__title">La Sine bruke verktøy?</p>
          {data.reason && (
            <p className="suggest-agent-card__reason">{data.reason}</p>
          )}
        </div>
      </div>
      <div className="suggest-agent-card__actions">
        <button
          className="suggest-agent-card__btn suggest-agent-card__btn--primary"
          onClick={onSwitchToAgent}
        >
          Bruk verktøy
        </button>
        <button
          className="suggest-agent-card__btn suggest-agent-card__btn--secondary"
          onClick={onContinueInChat}
        >
          Svar kort
        </button>
      </div>
    </div>
  )
}
